import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import 'bootstrap/dist/css/bootstrap.css';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Input,
	Container,
	Row,
	Col,
} from 'reactstrap';

function App() {
	const [password, setPassword] = useState('');
	const [passwordLength, setPasswordLength] = useState(8);
	const [useSymbols, setUseSymbols] = useState(false);

	const generatePassword = () => {
		const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

		const characters =
			'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890' +
			(useSymbols ? symbols : '');

		let generatedPassword = '';

		for (let i = 0; i < passwordLength; i++) {
			const randomIndex = Math.floor(Math.random() * characters.length);
			generatedPassword += characters[randomIndex];
		}

		setPassword(generatedPassword);
		copyToClipboard(generatedPassword);
		showToast();
	};

	const copyToClipboard = (text) => {
		navigator.clipboard.writeText(text);
	};

	const showToast = () => {
		toast.success('Password copiata', {
			position: 'top-center',
			autoClose: 2000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: false,
		});
	};

	return (
		<div className="App">
			<Header />
			<Container>
				<Row className="justify-content-center mt-4">
					<Col xs={12} md={6}>
						<Form>
							<FormGroup>
								<Label className="text-center w-100">
									Lunghezza: {passwordLength}
								</Label>
								<Input
									type="range"
									min="8"
									max="20"
									value={passwordLength}
									onChange={(e) => setPasswordLength(e.target.value)}
								/>
							</FormGroup>

							<FormGroup check className="text-center">
								<Label check>
									<Input
										type="checkbox"
										checked={useSymbols}
										onChange={(e) => setUseSymbols(e.target.checked)}
									/>{' '}
									Usa simboli speciali
								</Label>
							</FormGroup>

							<FormGroup>
								<Input
									type="text"
									readOnly
									value={password}
									style={{ fontSize: '1.5rem' }}
									className="output-password my-5 text-center"
								/>
							</FormGroup>

							<Button
								color="primary"
								onClick={generatePassword}
								style={{ width: '100%' }}
								className="btn-xl d-inline-block mx-auto mt-3"
							>
								Genera
							</Button>
						</Form>
					</Col>
				</Row>
			</Container>

			<ToastContainer />
		</div>
	);
}

export default App;
